import { lazy } from 'react';

export const FarmerCriteriaIndexPage = lazy(
  () => import('./ui/FarmerCriteriaIndexPage/FarmerCriteriaIndexPage'),
);
export const FarmerCriteriaFormPage = lazy(
  () => import('./ui/FarmerCriteriaFormPage/FarmerCriteriaFormPage'),
);

export const FarmerCriteriaDetailsPage = lazy(
  () => import('./ui/FarmerCriteriaDetails/FarmerCriteriaDetails'),
);
